import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../util/api';
import './PageTree.css';

interface PageItem {
    id: number;
    slug: string;
    title: string;
}

interface PageTreeProps {
    onSelect?: () => void;
}

export const PageTree: React.FC<PageTreeProps> = ({ onSelect }) => {
    const [pages, setPages] = useState<PageItem[]>([]);
    const [loading, setLoading] = useState(true);
    const [showAddForm, setShowAddForm] = useState(false);
    const [newSlug, setNewSlug] = useState('');
    const [newTitle, setNewTitle] = useState('');

    const fetchPages = () => {
        setLoading(true);
        api.get<PageItem[]>('/api/pages/')
            .then(res => {
                setPages(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error("Failed to fetch pages", err);
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchPages();
    }, []);

    const handleAddPage = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!newSlug || !newTitle) return;

        try {
            await api.post('/api/pages/create_page/', {
                slug: newSlug,
                title: newTitle,
                content: { version: 1, rows: [] }
            });
            setNewSlug('');
            setNewTitle('');
            setShowAddForm(false);
            fetchPages();
        } catch (err) {
            console.error("Failed to create page", err);
            alert("Failed to create page. Slug might already exist.");
        }
    };

    if (loading) return <div className="page-tree-loading">Loading pages...</div>;

    return (
        <div className="page-tree">
            <h3>Site Pages</h3>
            <button className="add-page-toggle" onClick={() => setShowAddForm(!showAddForm)}>
                {showAddForm ? 'Cancel' : '+ Add New Page'}
            </button>

            {showAddForm && (
                <form className="add-page-form" onSubmit={handleAddPage}>
                    <input
                        type="text"
                        placeholder="Page Title (e.g. Gallery)"
                        value={newTitle}
                        onChange={e => setNewTitle(e.target.value)}
                        required
                    />
                    <input
                        type="text"
                        placeholder="slug (e.g. gallery)"
                        value={newSlug}
                        onChange={e => setNewSlug(e.target.value.toLowerCase().replace(/ /g, '-'))}
                        required
                    />
                    <button type="submit">Create Page</button>
                </form>
            )}

            <ul>
                {pages.map(page => (
                    <li key={page.id}>
                        <Link to={`/${page.slug}`} onClick={onSelect}>
                            {page.title} <span className="slug-hint">({page.slug})</span>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
};
